import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    browse: {
        id: "menu.browse",
    },
    testModeration: {
        id: "menu.moderation",
    },
});

export default messages;
